/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutomaticEmailStepBodyDoc } from './automaticEmailStepBodyDoc';
import type { AutomaticEmailStepPriority } from './automaticEmailStepPriority';
import type { AutomaticEmailStepSubjectDoc } from './automaticEmailStepSubjectDoc';
import type { AutomaticEmailStepSubjectMode } from './automaticEmailStepSubjectMode';
import type { AutomaticEmailStepThreadMode } from './automaticEmailStepThreadMode';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface AutomaticEmailStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: AutomaticEmailStepPriority;
  subject_mode: AutomaticEmailStepSubjectMode;
  subject_doc?: AutomaticEmailStepSubjectDoc;
  body_doc: AutomaticEmailStepBodyDoc;
  thread_mode?: AutomaticEmailStepThreadMode;
  /** @maxItems 20 */
  cc?: string[];
  /** @maxItems 20 */
  bcc?: string[];
  include_sender_signature?: boolean;
  include_unsubscribe_link?: boolean;
  type: 'automatic_email';
}
